import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";
import { SalesFunnelStage } from "@/services/dashboardService";

interface OpportunityPieChartProps {
  data: SalesFunnelStage[];
}

export function OpportunityPieChart({ data }: OpportunityPieChartProps) {
  const chartData = data
    .filter(stage => stage.opportunities_count > 0)
    .map(stage => ({
      name: stage.stage_name,
      value: stage.opportunities_count,
      color: stage.stage_color,
      totalValue: stage.total_value,
    }));

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white/90 backdrop-blur-md p-3 border border-slate-200/50 rounded-lg shadow-xl shadow-slate-200/50">
          <p className="font-semibold text-slate-900">{payload[0].name}</p>
          <p className="text-sm text-slate-600 mt-1">
            Oportunidades: <span className="font-medium text-slate-900">{payload[0].value}</span>
          </p>
          <p className="text-sm text-slate-600">
            Valor Total: <span className="font-medium text-slate-900">${payload[0].payload.totalValue.toLocaleString()}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <Card className="bg-white/80 backdrop-blur-xl border border-white/40 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-slate-800">Oportunidades por Etapa</CardTitle>
      </CardHeader>
      <CardContent>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={70}
                outerRadius={100}
                paddingAngle={3}
                dataKey="value"
                stroke="none"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} cursor={{fill: 'transparent'}} />
              <Legend 
                verticalAlign="bottom" 
                height={36}
                formatter={(value) => <span className="text-sm font-medium text-slate-600">{value}</span>}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="flex items-center justify-center h-[300px] text-slate-400 font-medium">
            No hay oportunidades registradas
          </div>
        )}
      </CardContent>
    </Card>
  );
}